module.exports = __webpack_public_path__ + "h5assets/img/collabs-level-company-tw@2x.9a1e662.png";